import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/svgs/microsoft.svg'
import _imports_1 from '@/assets/svgs/google.svg'


const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-row justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold py-2" }, "My Calendar", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mr-4" }, "Scheduling pages"),
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    class: "w-6 h-6"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"
    })
  ])
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col items-center mt-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-56 h-12"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex flex-row items-center justify-between w-56 h-12",
  style: {"background-color":"#4285f4"}
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-white font-roboto" }, "Sign in with Google")
  ])
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col bg-white shadow rounded-2xl px-5 py-3 mt-4"
}
const _hoisted_12 = { class: "flex flex-row items-center justify-between" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold py-2" }, "Microsoft Teams", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mr-4" }, "Link teams"),
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
    })
  ])
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "flex flex-row justify-end w-full space-x-3 items-center mt-4 mb-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-tiny font-light" }, " Linked to teams: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.isCalendarLinked)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewSchedulingPages && _ctx.viewSchedulingPages(...args))),
              class: "btn-text"
            }, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isCalendarLinked)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.connectCalendar(''))),
              class: "w-56 h-12"
            }, _hoisted_8),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.connectCalendar('gmail'))),
              class: "mt-4"
            }, _hoisted_10)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isCalendarLinked && (_ctx.provider == 'eas' || _ctx.provider === 'ews'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            (!_ctx.teams.is_linked)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getLinkedURL && _ctx.getLinkedURL(...args))),
                  class: "btn-text"
                }, _hoisted_15))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm font-light px-2 py-1 rounded", 
            _ctx.teams.is_linked
              ? 'bg-green-100 text-green-500'
              : 'bg-red-200 text-red-500'
          ])
            }, _toDisplayString(_ctx.teams.is_linked ? "Connected" : "Not connected"), 3)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}